
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexDfAMow0DzXfmsrL2YAXCgElXdKNpBjscVA557CT7UMEMeta } from "/tmp/tmphhf7t3xx/pages/index.vue?macro=true";
import { default as indexkkFIhIKXp1x8m6LtJhcMwSEEj4eZD9JqIRnSSL3l2i8Meta } from "/tmp/tmphhf7t3xx/pages/[area]/index.vue?macro=true";
import { default as indexOvYlPmtn2lWoPhzo_45Ek9M8RUHdfQhqjDj8Wwq_45uopgwMeta } from "/tmp/tmphhf7t3xx/pages/okinawa/index.vue?macro=true";
import { default as indexixu1P6IZ40Ct3jR_45TNCj0ukHu9DasrYPfumd_453isl0oMeta } from "/tmp/tmphhf7t3xx/pages/ranking/index.vue?macro=true";
import { default as index7e4XQr2rRUr6_xIg4DvQn6pOkwIB8f5etZe5LXukQ8EMeta } from "/tmp/tmphhf7t3xx/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexxnOVqvgLvMy_45S_45SRbcwuKS9G8yyOvOXoT2PDfLF_45zl0Meta } from "/tmp/tmphhf7t3xx/pages/[area]/[pref]/index.vue?macro=true";
import { default as indexoEAzEtPdnyJHvVtJj3ePsMABmOsyLw_q_uMtW87L6gsMeta } from "/tmp/tmphhf7t3xx/pages/ranking/[area]/index.vue?macro=true";
import { default as indexJ9iMgdnXVEPz59eSgY4rmDaxLxZe8GeA0elS9HGVaB0Meta } from "/tmp/tmphhf7t3xx/pages/[area]/[pref]/[id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmphhf7t3xx/pages/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmphhf7t3xx/pages/[area]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmphhf7t3xx/pages/okinawa/index.vue")
  },
  {
    name: "ranking",
    path: "/ranking",
    component: () => import("/tmp/tmphhf7t3xx/pages/ranking/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmphhf7t3xx/pages/okinawa/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmphhf7t3xx/pages/[area]/[pref]/index.vue")
  },
  {
    name: "ranking-area",
    path: "/ranking/:area()",
    component: () => import("/tmp/tmphhf7t3xx/pages/ranking/[area]/index.vue")
  },
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmphhf7t3xx/pages/[area]/[pref]/[id]/index.vue")
  }
]